<template>
  <div class="main-r-wrap">
     <div class="main-r-top">
       <span
         class="main-r_top_nav"
         :class="mainStatus === 'online' && 'active'"
         @click.stop="handleClick('online')"
       >{{$t('apiDoc.在线文档')}}</span>
       <span
         class="main-r_top_nav"
         :class="mainStatus === 'apiTest' && 'active'"
         @click.stop="handleClick('apiTest')"
       >{{$t('apiDoc.测试工具')}}</span>
     </div>
     <!-- 在线文档 START -->
     <div class="main-r-bottom" v-show="mainStatus === 'online'">
       <online-doc :onlineData="onlineData"></online-doc>
     </div>
     <!-- 在线文档 END -->
     <!-- 测试工具 START -->
     <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
       <api-test-doc :apiTestData="apiTestData"></api-test-doc>
     </div>
     <!-- 测试工具 END -->
   </div>
 </template>
 
 <script>
  import onlineDoc from "../components/onlineDoc";
 
 import apiTestDoc from "../components/apiTestDoc";
 
 
 import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
 const apiUrlTest = 'order/reservationDelivery';
 export default {
   components: { onlineDoc , apiTestDoc },
   data() { 
     return {
       mainStatus: "online",
       //当前请求URL
       apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,
 
       onlineData: {
         //接口描述
         apiDesc: `${this.$t('onlineDoc.客户可通过此接口进行预约派送')}`,
         //接口地址
         testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
         proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
         //参数描述  START
        postDataList:[
             
         //   请求头参数
             {
                 title:'Headers',
                 value:[
                     {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
                     {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
                     {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,}
                     ]
             },
              { 
                 title:`${this.$t('onlineDoc.请求参数')}`, 
                  value:[
                     {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                 ]
             },
             {
               title:`${this.$t('onlineDoc.业务参数')}`,
               value:[
                 {name: "customerCode",type: "String",require: "Y",normal: "J0086024071",describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
                 {name: "digest",type: "String",require: "Y",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe:`${this.$t('onlineDoc.signnew')}`},
                 {name: "conventionDate",type: "String",require: "Y",normal: "2022-01-14",describe:`${this.$t('onlineDoc.预约派送日期')}`},
                 {name: "conventionTimeSlot",type: "String",require: "Y",normal: "09:00-13:00",describe:`${this.$t('onlineDoc.预约派送时间段')}`},
                 {name: "countryCode",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.国家三字码')}`},
                 {name: "prov",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.省份')}`},
                 {name: "city",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.城市')}`},
                 {name: "area",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.区域')}`},
                 {name: "address",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.详细地址')}`},
                 {name: "waybillCode",type: "String",require: "Y",normal: "",describe:`${this.$t('onlineDoc.运单号')}`}
               ]
             },
 
         ],
         //参数描述  END
         //报文描述 start
         responseDataList:[
             
         //   响应参数
             {
                 title:`${this.$t('onlineDoc.响应参数')}`,
                 value:[
                     { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
                     {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
                     {name: "data",type: "Boolean",require: "Y",normal: "",describe: `${this.$t('onlineDoc.true 成功 false 失败')}`,},
                   ]
             }
 
         ],
         //请求示例
         requestCode: `Header：
     apiAccount=292508153084379141
     Content-Type=application/x-www-form-urlencoded
     digest=djEINdkT7aLeivrvhf91SQ==
     timestamp=1648536570679
 
 Body：
     bizContent={'customerCode':'J0086024316',
     'digest':'z8VNeUtbxTYq2NWDnvqbrQ==',
     'conventionDate':'2023-03-23',
     'conventionTimeSlot':'09:00-13:00',
     'countryCode':'KSA',
     'prov':'Hail',
     'city':'Hail',
     'area':'Aja_Ksa_Hail',
     'address':'guigyui',
     'waybillCode':'UTE010005764088'}`,
         //返回示例
         responseCode: JSON.parse(`{
     "code": "1",
     "msg": "success",
     "data": false
 }`),
 
         //错误代码提示
         errcodeJson: []
       },
 
       apiTestData: {
           _headerData: {
             apiAccount: "292508153084379141",
             digest: "U40e5sumorgd3YgZzU61Mw==",
             timestamp: "1565238848921",
           },
           data:{
              bizContent: `{'customerCode':'J0086024316','digest':'z8VNeUtbxTYq2NWDnvqbrQ==','conventionDate':'2023-03-23','conventionTimeSlot':'09:00-13:00','countryCode':'KSA','prov':'Hail','city':'Hail','area':'Aja_Ksa_Hail','address':'guigyui','waybillCode':'UTE010005764088'}`,
           },
         //必须要验证的参数
         requestData:['apiAccount','digest','timestamp','bizContent'],
         textareaData:{
           bizContent:true
         },
         //促发接口
         apiUrl: `/mock/${apiUrlTest}`,
         //返回
         ResponseJson: "",
         //当前请求URL
         apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
         //错误代码提示
         errcodeJson: []
       },
     };
   },
  created() {},
   methods: {
     handleClick(status) {
       this.mainStatus = status;
     }
   },
  }
 </script>
 
 <style lang="scss" scoped>
 @import "../../css/apiTest.scss";
 </style>